
const digest = 'd999b6dcd160bcad8de95365962bf337582bc5ae7b2a10a0d04e1f29157a4908';
const css = `._toolbar_1paqt_1 {
  border-radius: var(--aha-editor-v2--border-radius)
    var(--aha-editor-v2--border-radius) 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 30px;
  background-color: var(--theme-editor-toolbar);
  position: relative;
  padding: 3px;
}

._elementToolbarButton_1paqt_13 svg {
  pointer-events: none;
}

/* Don't change toolbar in fullscreen. Seems unnecessary now toolbar is bigger.
.toolbar.fullScreen {
  visibility: visible !important;
  margin: 0 !important;
  border-radius: 0 !important;
  border-bottom: 1px solid var(--aha-blue-200);

  .toolbarButton {
    font-size: 15px !important;
    i {
      font-size: 15px !important;
    }
    line-height: 1.5;
  }
}
*/

._toolbarItems_1paqt_34 {
  display: flex;
  align-items: center;
  gap: 1px;
  opacity: 1;
  transition: opacity 0.2s;
}

._faded_1paqt_42 {
  opacity: 0;
  transition: opacity 0s;
}

._toolbarSection_1paqt_47 {
  display: flex;
  flex-direction: row;
}

._toolbarButton_1paqt_24,
._toolbarItem_1paqt_34 {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--editor-v2-toolbar-button-color);
  border-radius: var(--editor-v2-toolbar-button-radius);
  font-size: var(--editor-v2-toolbar-button-font-size);
  height: var(--editor-v2-toolbar-button-size);
  min-width: var(--editor-v2-toolbar-button-size);
  font-weight: 400;
  line-height: var(--editor-v2-toolbar-button-font-size);
  padding: 2px 5px;
  margin: 1px;
}

._hideCaret_1paqt_69::after {
  display: none;
}

._toolHDivider_1paqt_73 {
  border-right: 1px solid var(--theme-secondary-border);
  margin: 4px 5px;
}

._toolbarButton_1paqt_24 .fa-caret-down {
  margin-left: 0.3rem;
}

._toolbarButton_1paqt_24:hover,
._toolbarItem_1paqt_34:hover {
  background-color: var(--theme-editor-button-hovered);
  color: var(--aha-gray-900);
}

._toolbarButton_1paqt_24:active,
._toolbarItem_1paqt_34:active,
aha-menu[open] > ._toolbarButton_1paqt_24,
aha-menu[open] > ._toolbarItem_1paqt_34 {
  color: var(--aha-blue-700);
  background-color: var(--aha-blue-300);
}

._toolbarButton_1paqt_24[aria-disabled='true'],
._toolbarItem_1paqt_34[aria-disabled='true'] {
  opacity: 0.3;
  pointer-events: none;
}

._toolbarButton_1paqt_24[aria-selected='true'],
._toolbarItem_1paqt_34[aria-selected='true'] {
  color: var(--aha-blue-700);
  background-color: var(--theme-editor-button-active);
}

._toolbarButtonText_1paqt_108 {
  font-size: 12px;
  padding: 0 5px;
  display: flex;
  align-items: center;
  gap: 5px;
}

/* We need to override all styles so we override the bootstrap form.less styles
 * that are applied to all inputs. */
._toolbarInput_1paqt_118 {
  width: 200px;
  border: none;
  padding: 3px !important;
  margin: 0 !important;
  border-radius: var(--Common--border-radius) !important;
  box-shadow: none !important;
}
._toolbarInput_1paqt_118:focus {
  outline: 2px solid var(--aha-blue-400) !important;
  box-shadow: none !important;
}

._hintToolShortcut_1paqt_131 {
  padding: 2px 4px;
  border-radius: 3px;
  background-color: rgba(255, 255, 255, 0.2);
}

._cellBackgroundColorIcon_1paqt_137 {
  width: 14px;
  height: 14px;
  border: 1px solid var(--theme-secondary-border);
  border-radius: 50%;
}

._tableBorderColorIcon_1paqt_144 {
  display: block;
  width: 12px;
  height: 12px;
  border: 3px solid var(--theme-secondary-border);
  border-radius: 50%;
}

._colorIconNone_1paqt_152 {
  background: linear-gradient(
    to top right,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0) calc(50% - 2px),
    rgb(214, 157, 157) 50%,
    rgba(0, 0, 0, 0) calc(50% + 2px),
    rgba(0, 0, 0, 0) 100%
  );
}

._toolbar_1paqt_1 aha-tooltip {
  --Tooltip__tooltip--font-size: 14px;
}

._toolbarMenuItem_1paqt_167 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

._toolbarMenuItemLabel_1paqt_173 {
  display: flex;
  flex: 1 1;
  gap: var(--spacer-1);
  align-items: center;
}

._toolbarMenuItemShortcut_1paqt_180 {
  color: var(--theme-light-gray-700-dark-gray-200);
}

._alternateRowColorIcon_1paqt_184 {
  position: relative;
}

._alternateRowColorCircle_1paqt_188 {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -2px;
  right: -2px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: var(--theme-primary-background);
}

._alternateRowColorCircleInner_1paqt_201 {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--aha-gray-100);
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"toolbar":"_toolbar_1paqt_1","elementToolbarButton":"_elementToolbarButton_1paqt_13","toolbarItems":"_toolbarItems_1paqt_34","faded":"_faded_1paqt_42","toolbarSection":"_toolbarSection_1paqt_47","toolbarButton":"_toolbarButton_1paqt_24","toolbarItem":"_toolbarItem_1paqt_34","hideCaret":"_hideCaret_1paqt_69","toolHDivider":"_toolHDivider_1paqt_73","toolbarButtonText":"_toolbarButtonText_1paqt_108","toolbarInput":"_toolbarInput_1paqt_118","hintToolShortcut":"_hintToolShortcut_1paqt_131","cellBackgroundColorIcon":"_cellBackgroundColorIcon_1paqt_137","tableBorderColorIcon":"_tableBorderColorIcon_1paqt_144","colorIconNone":"_colorIconNone_1paqt_152","toolbarMenuItem":"_toolbarMenuItem_1paqt_167","toolbarMenuItemLabel":"_toolbarMenuItemLabel_1paqt_173","toolbarMenuItemShortcut":"_toolbarMenuItemShortcut_1paqt_180","alternateRowColorIcon":"_alternateRowColorIcon_1paqt_184","alternateRowColorCircle":"_alternateRowColorCircle_1paqt_188","alternateRowColorCircleInner":"_alternateRowColorCircleInner_1paqt_201"};
export { css, digest };
  